var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpouseTemporary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spouseTemporary-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-30.693)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spouseTemporary",
    transform: "translate(30.693)",
    clipPath: "url(#spouseTemporary-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.836,3.316A2.9,2.9,0,0,0,23,1a.579.579,0,0,0,0,1.158,1.737,1.737,0,1,1,0,3.474.579.579,0,0,0,0,1.158,2.9,2.9,0,0,0,2.836-2.316h7.585V9.684H2.158V4.474H12a.579.579,0,1,0,0-1.158H10.949a1.734,1.734,0,1,1,1.63,2.316.579.579,0,1,0,0,1.158A2.895,2.895,0,1,0,9.743,3.316H1V34H34.579V3.316Zm7.585,29.526H2.158v-22H33.421Z",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.44,2.675a1.737,1.737,0,1,1,0,3.474.579.579,0,1,0,0,1.158,2.895,2.895,0,0,0,0-5.789.579.579,0,1,0,0,1.158Z",
    transform: "translate(-11.388 -0.228)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.647,2.675a1.737,1.737,0,1,1,0,3.474.579.579,0,0,0,0,1.158,2.895,2.895,0,1,0,0-5.789.579.579,0,0,0,0,1.158Z",
    transform: "translate(-14.121 -0.228)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3,26.468a.579.579,0,1,0-.579-.579A.579.579,0,0,0,23.3,26.468Z",
    transform: "translate(-9.566 -10.705)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.544,26.468a.579.579,0,1,0-.579-.579A.579.579,0,0,0,30.544,26.468Z",
    transform: "translate(-12.755 -10.705)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.786,26.468a.579.579,0,1,0-.579-.579A.579.579,0,0,0,37.786,26.468Z",
    transform: "translate(-15.944 -10.705)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.028,26.468a.579.579,0,1,0-.579-.579A.579.579,0,0,0,45.028,26.468Z",
    transform: "translate(-19.133 -10.705)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.268,26.468a.579.579,0,1,0-.579-.579A.579.579,0,0,0,52.268,26.468Z",
    transform: "translate(-22.321 -10.705)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.821,34.744a.579.579,0,1,0-.579-.579A.579.579,0,0,0,8.821,34.744Z",
    transform: "translate(-3.189 -14.349)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.061,34.744a.579.579,0,1,0-.579-.579A.579.579,0,0,0,16.061,34.744Z",
    transform: "translate(-6.377 -14.349)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3,34.744a.579.579,0,1,0-.579-.579A.579.579,0,0,0,23.3,34.744Z",
    transform: "translate(-9.566 -14.349)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.544,34.744a.579.579,0,1,0-.579-.579A.579.579,0,0,0,30.544,34.744Z",
    transform: "translate(-12.755 -14.349)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.786,34.744a.579.579,0,1,0-.579-.579A.579.579,0,0,0,37.786,34.744Z",
    transform: "translate(-15.944 -14.349)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.028,34.744a.579.579,0,1,0-.579-.579A.579.579,0,0,0,45.028,34.744Z",
    transform: "translate(-19.133 -14.349)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.268,34.744a.579.579,0,1,0-.579-.579A.579.579,0,0,0,52.268,34.744Z",
    transform: "translate(-22.321 -14.349)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.821,41.986a.579.579,0,1,0-.579-.579A.579.579,0,0,0,8.821,41.986Z",
    transform: "translate(-3.189 -17.538)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.061,41.986a.579.579,0,1,0-.579-.579A.579.579,0,0,0,16.061,41.986Z",
    transform: "translate(-6.377 -17.538)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3,41.986a.579.579,0,1,0-.579-.579A.579.579,0,0,0,23.3,41.986Z",
    transform: "translate(-9.566 -17.538)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.544,41.986a.579.579,0,1,0-.579-.579A.579.579,0,0,0,30.544,41.986Z",
    transform: "translate(-12.755 -17.538)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.786,41.986a.579.579,0,1,0-.579-.579A.579.579,0,0,0,37.786,41.986Z",
    transform: "translate(-15.944 -17.538)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.028,41.986a.579.579,0,1,0-.579-.579A.579.579,0,0,0,45.028,41.986Z",
    transform: "translate(-19.133 -17.538)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.268,41.986a.579.579,0,1,0-.579-.579A.579.579,0,0,0,52.268,41.986Z",
    transform: "translate(-22.321 -17.538)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.821,50.261a.579.579,0,1,0-.579-.579A.579.579,0,0,0,8.821,50.261Z",
    transform: "translate(-3.189 -21.182)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.061,50.261a.579.579,0,1,0-.579-.579A.579.579,0,0,0,16.061,50.261Z",
    transform: "translate(-6.377 -21.182)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3,50.261a.579.579,0,1,0-.579-.579A.579.579,0,0,0,23.3,50.261Z",
    transform: "translate(-9.566 -21.182)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.544,50.261a.579.579,0,1,0-.579-.579A.579.579,0,0,0,30.544,50.261Z",
    transform: "translate(-12.755 -21.182)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.786,50.261a.579.579,0,1,0-.579-.579A.579.579,0,0,0,37.786,50.261Z",
    transform: "translate(-15.944 -21.182)",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpouseTemporary);
export default __webpack_public_path__ + "static/media/spouseTemporary.5006f8b96062afd76a8f4200138d52e7.svg";
export { ForwardRef as ReactComponent };